import {
  WSMessageBox,
  WSModal,
  WSText
} from "@wingspanhq/fe-component-library";
import React from "react";

export const TaxesModalQuarterInfo: React.FC = () => (
  <WSModal name="quarter-info">
    <WSText.Heading2 mb="S">
      When should I send my quarterly estimate payment to the IRS?
    </WSText.Heading2>
    <WSText.Paragraph mb="S">
      We recommend sending your quarterly estimates 2 weeks before the due date
      to avoid the IRS’s penalty for underpayment of estimated taxes.
    </WSText.Paragraph>
    <WSText.Label mt="M" color="grey600">
      TIP: If you’re tempted to withdraw for non-emergencies, we recommend
      making regular payments to the IRS.
    </WSText.Label>
  </WSModal>
);
